module.exports = __webpack_public_path__ + "static/media/suhail_profile.ea13cff4.jpg";